import { Component, ViewEncapsulation, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { PropertyService } from './shared/property.service';
import { MatSidenavModule } from '@angular/material';
import { EventService } from './shared/event.service';

@Component({
  selector: 'sold-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css',
    './sidenav.css',
    './branded.scss',
  ]
})

export class AppComponent {
  @ViewChild('sidenav') el: ElementRef;
  toggleType = '';
  scrollheight = '20px';
  showMainHeader: boolean = true;
  showFormHeader: boolean = false;
  showFooter: boolean = true;
  phonePopup: boolean = false;
  deviceWidth: any;

  showViewingform: boolean = false;
  showMap: boolean = false;
  showFeatures: boolean = false;

  showLoader: boolean = true;

  constructor(private _eventService: EventService, private rd: Renderer2, public _propertyService: PropertyService) {
    this.deviceWidth = (window.screen.width);
    _eventService.eventSenderSource$.subscribe(a => {
      this.onCloseNavClicked(this.el);
      this.showHeaderFooter();
      });
      // this.resizeMiddleSection();
  }

  resizeMiddleSection(): void {
    this.scrollheight = (window.screen.height - 300) + 'px';
  }

  valuationLinkClicked() {
    //console.log("val clidk");
  }

  onCloseNavClicked(sidenav: any): void {

    this.showViewingform = false;
    this.showMap = false;
    this.showFeatures = false;
    sidenav.toggle();
  }

  onOpenNavClicked(sidenav: any, title: string): void {

    this.showViewingform = false;
    this.showMap = false;
    this.showFeatures = false;

    if (!sidenav._opened) {
      this.toggleType = title;
      sidenav.toggle();
    } else {
      if (this.toggleType === title) {
        this.toggleType = title;
        sidenav.toggle();
      } else {
        this.toggleType = title;
      }
    }

    if (sidenav._opened) {
      if (title === 'viewing') {
        this.hideHeaderFooter();
        this.showViewingform = true;
      }
      if (title === 'map') {
        this.showMap = true;
      }
      if (title === 'features') {
        this.showFeatures = true;
      }
      if (title === 'close') {
        this.showHeaderFooter();
        sidenav.toggle();
      }
    } else {
      if (title === 'close') {
        this.showHeaderFooter();
      }
    }
  }
  hideHeaderFooter(): void {
    this.showFormHeader = true;
    this.showMainHeader = false;
    this.showFooter = false;
  }

  showPhonePopup() {
    if (this.deviceWidth > 767) {
      this.phonePopup = true;
    }
  }

  hidePhonePopup() {
    this.phonePopup = false;
  }

  showHeaderFooter(): void {
    this.showFormHeader = false;
    this.showMainHeader = true;
    this.showFooter = true;
  }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/app.component.ts